require('./articles.less');



// WEBPACK FOOTER //
// ./blocks/articles/articles.js